import { createFileRoute } from '@tanstack/react-router'
import SettingsServiceAccountsPage from '@/components/pages/Settings/team/SettingsServiceAccountsPage/SettingsServiceAccountsPage'

export const Route = createFileRoute(
  '/$workspaceName/$environment/team-settings/service-accounts/',
)({
  component: ServiceAccountsSettingsRoute,
})

function ServiceAccountsSettingsRoute() {
  return <SettingsServiceAccountsPage />
}
